module.exports = __webpack_public_path__ + "img/GEORGIA-FS-FC.7d04edb7.png";